import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExceptionNotificationsResponse } from "services/api/exceptionNotifications";

/**
 * Exception notification settings for the current account, shared between
 * the Exceptions v2 page (the Notifications button summary) and the
 * exceptionNotifications drawer, which the global drawer host renders.
 */
export interface IExceptionNotificationsSlice {
  salesAccountUUID: string | null;
  data: ExceptionNotificationsResponse | null;
  failed: boolean;
}

const initialState: IExceptionNotificationsSlice = {
  salesAccountUUID: null,
  data: null,
  failed: false,
};

export const exceptionNotificationsSlice = createSlice({
  name: "exceptionNotificationsSlice",
  initialState,
  reducers: {
    setExceptionNotifications: (
      state,
      action: PayloadAction<{
        salesAccountUUID: string;
        data: ExceptionNotificationsResponse | null;
        failed?: boolean;
      }>
    ) => {
      state.salesAccountUUID = action.payload.salesAccountUUID;
      state.data = action.payload.data;
      state.failed = action.payload.failed ?? false;
    },
  },
});

export const { setExceptionNotifications } =
  exceptionNotificationsSlice.actions;
